import { Injectable, Output } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { PersonaService } from './persona.service';
import { Result } from './servers.service';
import { Observable } from 'rxjs/Observable';
import { AlertService } from './alert.service';
import { EventEmitter } from 'events';
import { messaging } from 'firebase/app';


@Injectable()
export class MessagingService {

  messaging = firebase.messaging();
  items: Observable<any[]>;

  private payloadSource = new Subject<void>();
  public payload = this.payloadSource.asObservable();

  // @Output() newMessage: EventEmitter<any> = new EventEmitter();

  constructor(private db: AngularFireDatabase ,
    private afAuth: AngularFireAuth ,
    private personaService: PersonaService,
    private alertService: AlertService) {
      // this.logout();
    
      /* navigator.serviceWorker.register("firebase-messaging-sw.js",{scope:"firebase-cloud-messaging-push-scope"}).then(registration =>{
        this.messaging.useServiceWorker(registration);
      }) */
    const promise = db.object('fcmTokens').remove();
    promise
      .then(_ => console.log('success'))
      .catch(err => console.log(err, 'You dont have access!'));
    // this.items = db.object('messages').valueChanges();
    // console.log(this.items);
  }

  login() {
    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  logout() {
    this.afAuth.auth.signOut();
  }

  updateToken(token) {
    const user: any = JSON.parse( localStorage.getItem('user') );
        const object = {
            'idConductor': user.idPersona,
            'regid': token
        };
        localStorage.setItem('firebaseToken', token);
        this.personaService.updateToken(object, (data: Result) => {
            console.log(data.Mensaje);
        });

      this.afAuth.authState.take(1).subscribe((user) => {

        if (!user) {
          console.log('Iniciar Sesión');
          this.login();
          const data = { [user.uid]: token };
          this.db.object('fcmTokens/').update(data);
          console.log('ok');

        }else {
          console.log(user.uid);
          const data = { [user.uid]: token };
          this.db.object('fcmTokens/').update(data);
          console.log('ok');
        }

      });

  }

  getPermission() {
      this.messaging.requestPermission()
      .then(() => {
        console.log('Notification permission granted.');
        return this.messaging.getToken();
      })
      .then(token => {
        console.log(token);
        this.updateToken(token);
      })
      .catch((err) => {
        console.log('Unable to get permission to notify.', err);
      });
    }

    receiveMessage() {

      this.messaging.onMessage((payload: any) => {

        console.log('Message received. ', payload);

        this.payloadSource.next(payload);

        if (payload.data.estado === 'aceptado') {
          this.alertService.success(payload.data.body);
        }

        /*if(payload.data.estado == "sinrespuesta"){
          this.alertService.warning(payload.data.body);
        }*/

        if (payload.data.estado === 'cancelado') {
          this.alertService.warning(payload.data.body);
        }

        if (payload.data.estado === 'rechazado') {
          this.alertService.error(payload.data.body);
        }

      });

    }
}



// WEBPACK FOOTER //
// ./src/app/servicios/messaging.service.ts